<template>
	<header class="new-toolbar" :class="toolbarClasses">
		<div class="new-toolbar__inner new-layout-container">
			<router-link v-if="showLogo" class="new-toolbar__logo" to="/calendar" aria-label="Blumar Congressos e Eventos">
				<img
					class="new-toolbar__logo-image"
					:src="translationLogo"
					alt="Blumar Congressos e Eventos"
					@error="usePortugueseLogo"
				>
			</router-link>
			<p v-if="eventLabel" class="new-toolbar__event-label">{{eventLabel}}</p>

			<div class="new-toolbar__actions">
				<language-dropdown />
				<button class="new-toolbar__menu" type="button" @click="$emit('open-menu')" aria-label="Abrir menu">
					<span></span>
					<span></span>
					<span></span>
				</button>
			</div>
		</div>
	</header>
</template>

<script>
import LanguageDropdown from './LanguageDropdown.vue';

export default {
	components: {
		LanguageDropdown,
	},
	props: {
		variant: {
			type: String,
			default: 'solid',
		},
		eventLabel: {
			type: String,
			default: '',
		},
		showLogo: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		translationLogo() {
			const language = this.$store.state.language;
			const languageCode = language && language.lang ? language.lang : 'pt';
			return `/static/logo_blumar_${languageCode}.png`;
		},
		toolbarClasses() {
			return {
				'new-toolbar--transparent': this.variant === 'transparent',
				'new-toolbar--solid': this.variant !== 'transparent',
			};
		},
	},
	methods: {
		usePortugueseLogo(event) {
			const portugueseLogo = '/static/logo_blumar_pt.png';
			if (event.target.getAttribute('src') !== portugueseLogo) event.target.src = portugueseLogo;
		},
	},
};
</script>

<style scoped lang="scss">
.new-toolbar {
	left: 0;
	right: 0;
	z-index: 30;
	color: #ffffff;
}

.new-toolbar--transparent {
	position: absolute;
	top: 32px;
	background: transparent;
}

.new-toolbar--solid {
	position: relative;
	background: #0b3a52;
	box-shadow: 0 2px 8px rgba(4, 30, 45, .18);
}

.new-toolbar__inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 93px;
}

.new-toolbar__logo {
	display: inline-flex;
	align-items: center;
	text-decoration: none;
}

.new-toolbar__logo-image {
	display: block;
	width: 130px;
	height: auto;
}

.new-toolbar__event-label {
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: flex-end;
	min-width: 0;
	margin: 0 32px;
	color: #ffffff;
	font-size: 20px;
	//font-weight: 900;
	line-height: 23px;
	text-align: right;
	text-transform: uppercase;
}

.new-toolbar__actions {
	display: flex;
	align-items: center;
	gap: 18px;
	margin-left: auto;
}

.new-toolbar__menu {
	display: inline-flex;
	flex-direction: column;
	justify-content: center;
	gap: 6px;
	width: 36px;
	height: 36px;
	padding: 0;
	border: 0;
	background: transparent;
	cursor: pointer;
}

.new-toolbar__menu span {
	display: block;
	width: 28px;
	height: 2px;
	background: #ffffff;
}

@media (max-width: 720px) {
	.new-toolbar--transparent {
		top: 22px;
	}

	.new-toolbar__inner {
		min-height: 74px;
	}

	.new-toolbar__event-label {
		justify-content: flex-start;
		margin: 0 10px 0 18px;
		font-size: 11px;
		line-height: 12px;
		text-align: left;
	}

	.new-toolbar__actions {
		gap: 12px;
	}
}

@media (max-width: 560px) {
	.new-toolbar__logo-image {
		width: 115px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/shared/header/Header.vue